<template>
    <el-drawer
        title="一键批量退款"
        :visible.sync="visible"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <p class="tips">
                确认退款后，系统将自动进行退款，资金会原路返回至用户账户
            </p>
            <p class="tips">
                对于已经在支付平台成功退款的订单，则系统会自动退款状态，<span>但不会进行资金上的重复退款</span>
            </p>
            <div class="temp-table">
                <h3>可退款众筹</h3>
                <el-table
                    :data="refundList"
                    style="width: 100%"
                    size="small"
                    border
                >
                    <el-table-column prop="raiseId" label="众筹ID" min-width="90"></el-table-column>
                    <el-table-column prop="raiseName" label="众筹名称" min-width="300" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="orderNum" label="订单数" min-width="100"></el-table-column>
                    <el-table-column prop="totalAmountFormat" label="实际总收入" min-width="100"></el-table-column>
                    <el-table-column prop="refundAmountFormat" label="待退款金额" min-width="100"></el-table-column>
                </el-table>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="sub" :loading="subLoading">确认退款</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            visible:false,
            refundList: [],
            filter: {},
            subLoading: false
        }
    },
    methods: {
        show(refundList, filter) {
            this.refundList = refundList || [];
            this.filter = filter;
            this.visible = true;
        },
        close() {
            this.refundList = [];
            this.notRefundList = [];
            this.filter = {};
            this.visible = false;
        },
        async sub() {
            let _isReconciliationSuccess = 0;
            await this.$emit('reconciliationCheck',async (data) => {
                if( data && data.length > 0 ){
                    const flag = await this.$confirm(`系统检测到本次退款的数据包含<span class='color-danger'>${data.length}条</span>未收入对账或对账失败的数据，请选择处理方式`,"警报", {
                        confirmButtonText: '全部批量退款',
                        cancelButtonText: '只批量退对账成功',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).catch((action) => {return action});
                    if (flag === 'cancel') {
                        _isReconciliationSuccess = 1;
                    }else if(flag === 'close'){
                        return;
                    }
                }

                this.subLoading = true;
                const res = await this.$request({
                    url: '/raise/refund/batch/createTask',
                    method: 'post',
                    data: {...this.filter, isReconciliationSuccess: _isReconciliationSuccess}
                }).catch(() => {
                    return {data: {state: '0', msg: '请求错误'}};
                }).finally(() => {
                    this.subLoading = false;
                });

                const { state, msg} = res.data;

                if(state !== '1') {
                    return this.$message.error(msg || '请求失败');
                }

                this.$emit('subSuccess');
                this.close();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.tips span {
    color: #f56c6c;
}

.temp-table h3 {
    margin: 20px 0 10px 0;
}
</style>